import { useCallback, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useIdleTimer } from "react-idle-timer";
import { useDispatch } from "react-redux";
import { toast, ToastContent } from "react-toastify";

import { AppDispatch } from "../store/configureStore";
import { isAuthenticated, logoutRequested } from "../store/users/auth";

import 'react-toastify/dist/ReactToastify.css';

const IdleTimerComponent = () => {
  const { t } = useTranslation("common");

  const sessionTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  const dispatch = useDispatch<AppDispatch>();

    const logoutDelay = Number(window._env_.REACT_APP_SESSION_TIMEOUT || process.env.REACT_APP_SESSION_TIMEOUT) * 60 * 1000; // in milliseconds
  const warningDelay = 10 * 1000; // 10 seconds
  let startTime = Date.now();

  const onIdle = useCallback(() => {
    if (!isAuthenticated()) return;

      if (Date.now() - startTime >= Number(window._env_.REACT_APP_TOKEN_REQUEST_INTERVAL || process.env.REACT_APP_TOKEN_REQUEST_INTERVAL) * 60 * 1000) {
      dispatch(logoutRequested());
      return;
    }

    console.log("User is idle...");

    const toastMessage = t("common:idleNotificationMessage") + (warningDelay / 1000) + t("common:idleNotificationUnits");

    toast.warning(toastMessage as ToastContent<string>, {
      position: "top-center",
      autoClose: warningDelay,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: false
    });

    sessionTimeoutRef.current = setTimeout(logOut, warningDelay);
  }, [dispatch, startTime, warningDelay]);

  const stayLoggedIn = useCallback(() => {
    if (sessionTimeoutRef.current) {
      clearTimeout(sessionTimeoutRef.current);
    }
    startTime = Date.now();
  }, []);

  const logOut = useCallback(() => {
    if (sessionTimeoutRef.current) {
      clearTimeout(sessionTimeoutRef.current);
    }
    dispatch(logoutRequested());

    console.log("User logged out...");
  }, [dispatch]);

  const onAction = useCallback(() => {
    stayLoggedIn();
  }, [stayLoggedIn]);

  useIdleTimer({
    timeout: logoutDelay,
    onIdle,
    onAction,
    debounce: 500,
  });

  return null; // IdleTimer doesn't need to render anything
};

export default IdleTimerComponent;
